import ContactForm from '@/components/sections/contact/ContactForm'
import Container from '@/components/ui/Container'
import { useData } from '@/hooks/useLocale'

/** A picture of the app beside the demo-request form and our email addresses. */
export default function ContactSection() {
  const { CONTACT } = useData()

  return (
    <section className="flex-1 bg-surface py-14">
      <Container className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,380px),1fr))] items-stretch gap-5">
        <div className="flex overflow-hidden rounded-[28px] bg-ink">
          <img
            src={CONTACT.image}
            alt={CONTACT.imageAlt}
            className="block size-full object-cover object-left rtl:object-right"
          />
        </div>
        <div className="rounded-[28px] bg-white p-[26px] shadow-[0_30px_60px_-40px_rgba(20,30,50,.35)]">
          <ContactForm />
          <div className="mt-6 flex flex-col gap-2 border-t border-line pt-5 text-sm">
            <span className="font-medium text-ink">{CONTACT.emails.title}</span>
            {CONTACT.emails.items.map((item) => (
              <span key={item.email} className="text-muted">
                {item.label}:{' '}
                <a
                  href={`mailto:${item.email}`}
                  className="text-brand hover:text-brand-dark"
                >
                  {item.email}
                </a>
              </span>
            ))}
          </div>
        </div>
      </Container>
    </section>
  )
}
